// extracted by mini-css-extract-plugin
export var closed = "_a8-1";
export var resizer = "_a8-0";